<mat-card class="wrapper product-card"
          [ngClass]="{'big-card': cardType === 'big',
                      'basic-card': cardType === 'basic',
                      'list-card': cardType === 'list'}">

  <mat-card-content>
    <div class="product-card-image animate"></div>
    <div class="product-card-nfo">
      <div class="product-card-name animate"></div>

      <div class="product-card-price animate"></div>

      <div class="short-product-description animate"></div>
    </div>


  </mat-card-content>

</mat-card>
